import { r as registerInstance, h } from './index-d4808923.js';

const gravityIconIndividualCss = ":host{display:contents}";
const GravityIconAssetLocationStyle0 = gravityIconIndividualCss;

const GravityIconAssetLocation = class {
    constructor(hostRef) {
        registerInstance(this, hostRef);
        this.color = 'dark';
        this.size = 'xx-small';
    }
    render() {
        return (h("internal-gravity-base-icon", { key: 'e4abac516ddf937c0ad1fab41916aabe1a2b643b', color: this.color, size: this.size }, h("svg", { key: 'e0adf2f9c2055bb45fa542de2e3845c7826e1de3', width: "22", height: "22", viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, h("path", { key: '369f0b38ec403eae21410ae9a6cf9c5ee21152c9', "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M11 2a6 6 0 0 0-6 6c0 2.912 1.235 4.786 4.527 9.778l1.113 1.692a.4.4 0 0 0 .67 0c.58-.898 1.108-1.705 1.589-2.44C15.88 12.477 17 10.766 17 8a6 6 0 0 0-6-6Zm0 1.5A4.51 4.51 0 0 1 15.54 8c0 2.257-.955 3.712-3.667 7.845l-.193.295-.74 1.11-.23-.35-.053-.08C7.528 12.041 6.47 10.425 6.47 8A4.51 4.51 0 0 1 11 3.5Zm0 6a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3Z", fill: "currentColor" }))));
    }
};
GravityIconAssetLocation.style = GravityIconAssetLocationStyle0;

export { GravityIconAssetLocation as gravity_icon_asset_location };

//# sourceMappingURL=gravity-icon-asset-location.entry.js.map